import React from "react";

import { Text } from "widgets";
import { formatMonetaryAmount } from "utils/formatMonetaryAmount";

import styles from "./DisplayOrder.module.scss";

const DisplayOrder = (props) => {
  const { selectedPackageSubscriptions, currencyCode } = props;
  return (
    <div className={styles.orderSummaryContainer}>
      <Text>Selected Package Subscriptions</Text>
      {selectedPackageSubscriptions &&
      selectedPackageSubscriptions.length > 0 ? (
        selectedPackageSubscriptions.map((pkg, pkgIndex) => (
          <React.Fragment key={pkg.id ?? pkgIndex}>
            {pkg.subscriptions.map((subscription) => (
              <div key={subscription.id} className={styles.orderSummaryBox}>
                <div className={styles.label}>
                  <span className={styles.detailTitle}>Package Name:</span>
                  <span>{pkg.display_name}</span>
                </div>
                <div className={styles.label}>
                  <span className={styles.detailTitle}>Plan Name:</span>
                  <span>{subscription.plan_category.name}</span>
                </div>
                <div className={styles.label}>
                  <span className={styles.detailTitle}>Validity:</span>
                  <span>{pkg.validity_date}</span>
                </div>
                <div className={styles.label}>
                  <span className={styles.detailTitle}>MRP:</span>
                  <span>
                    {formatMonetaryAmount(subscription.mrp, currencyCode)}
                  </span>
                </div>
              </div>
            ))}
          </React.Fragment>
        ))
      ) : (
        <Text>No packages selected.</Text>
      )}
    </div>
  );
};

export default DisplayOrder;
